import Link from "next/link";
import Image from "next/image";

import styles from "@@/styles/components/ui/MediawindLogo.module.scss";

import { quicksand } from "@@/utils/fonts";

import logo from "@@/public/img/logo_mediawind.svg";
import logoWhite from "@@/public/img/logo_mediawind_white.svg";

import mediawind from "@@/public/img/mediawind.svg";
import mediawindWhite from "@@/public/img/mediawind_white.svg";

import { useHeaderCategoryContext } from "@@/hooks/contexts/headerCategroyContext";
import {JSX, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import { getSeoMeta } from '@@/utils/getSeoMeta';
import {usePathname} from "next/navigation";

interface IMediawindLogoProps {
	onClick?: CallableFunction;
	scrollTop?: boolean;
	backgroundIsWhite?: boolean;
	isMobile?: boolean;
	isFooter?: boolean;
}

export default function MediawindLogo(props: IMediawindLogoProps): JSX.Element {
	const { onClick, } = props;

	const { setHoveredCategory, } = useHeaderCategoryContext();

	const [seo, setSeo] = useState<{ title?: string; keywords?: string }>();
	const pathname = usePathname();
	const { i18n } = useTranslation();
	const locale = i18n.language;

	useEffect(() => {
		const page = extractPageKey(pathname);
		getSeoMeta(locale, page).then(setSeo);
	}, [pathname, locale]);

	function extractPageKey(pathname: string) {
		const parts = pathname.split('/');
		const key = parts[parts.length - 1] || 'home';
		return key;
	}

	function clickHandler() {
		if (onClick) {
			onClick();
		}

		setHoveredCategory(undefined);
	}

	return (
		<Link href={"/"} className={styles.main} onClick={clickHandler}>
			<div className={styles.logo_wrapper}>
				<Image
					src={logo}
					alt="Logo dark"
					className={`${styles.logo} ${(!props.scrollTop || props.backgroundIsWhite) ? styles.visible : styles.hidden}`}
					priority
				/>
				<Image
					src={logoWhite}
					alt="Logo white"
					className={`${styles.logo} ${(props.scrollTop && !props.backgroundIsWhite) ? styles.visible : styles.hidden}`}
					priority
				/>
			</div>
			<div className={styles.mediawind_wrapper} hidden={props.isMobile}>
				<Image
					hidden={props.isMobile}
					src={mediawind}
					alt="Mediawind dark"
					className={`${styles.mediawind} ${(!props.scrollTop || props.backgroundIsWhite) ? styles.visible : styles.hidden}`}
					priority
				/>
				<Image
					hidden={props.isMobile}
					src={mediawindWhite}
					alt="Mediawind white"
					className={`${styles.mediawind} ${(props.scrollTop && !props.backgroundIsWhite) ? styles.visible : styles.hidden}`}
					priority
				/>
			</div>
			{!props.isFooter && (
				<h1 className={`${styles.title} ${quicksand.className} ${styles.hidden}`}>
					{[seo?.title, seo?.keywords].filter(Boolean).join(' ')}
				</h1>
			)}
		</Link>
	);
}
